module.exports = __webpack_public_path__ + "img/red-icon(1).11b4ce49.png";